export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {children} = self.get();

    return (function() {
        var _obj = {
            'className': 'k-component-tip'
        };
        return parent.call($this, _obj, _Vdt, function(blocks) {
            var _blocks = {}, __blocks = extend({}, blocks);
            return ((_blocks['body'] = function(parent) {
                return [
                    function() {try {return (blocks.title )} catch(e) {_e(e)}}.call($this) ?
                        h('div', null, (_blocks['title'] = function(parent) {
                            return null;
                        }) && (__blocks['title'] = function(parent) {
                            var args = arguments;
                            return blocks['title'] ? blocks['title'].apply($this, [function() {
                                return _blocks['title'].apply($this, args);
                            }].concat(__slice.call(args, 1))) : _blocks['title'].apply($this, args);
                        }) && __blocks['title'].apply($this, [__noop]), 'k-title') :
                        undefined,
                    function() {try {return (children )} catch(e) {_e(e)}}.call($this)
                ];
            }) && (__blocks['body'] = function(parent) {
                var args = arguments;
                return blocks['body'] ? blocks['body'].apply($this, [function() {
                    return _blocks['body'].apply($this, args);
                }].concat(__slice.call(args, 1))) : _blocks['body'].apply($this, args);
            }), __blocks);
        }.call($this, blocks), parent)
    }).call($this)
}